document.addEventListener("DOMContentLoaded", ()=> {
    const sliders = document.querySelectorAll(".custom__slider");
    sliders.forEach((slider)=> {
        const showOnMobile = parseFloat(slider.dataset.mobile) || 1.8;
        const showOnDesktop = parseFloat(slider.dataset.desktop) || 5.5;
        const showOnTablet = parseFloat(slider.dataset.tablet) || 3.3;
        
        var swiper = new Swiper(slider, {
            autoplay: {
                delay: 3000,
                disableOnInteraction: true,
            },
            loop: true,
            slidesPerView: showOnMobile,
            spaceBetween: -40,
            navigation: {
                nextEl: slider.querySelector(".button-next"),
                prevEl: slider.querySelector(".button-prev"),
            },
            breakpoints: {
                640: {
                    slidesPerView: showOnMobile
                },
                768: {
                    slidesPerView: showOnTablet
                },
                1024: {
                    slidesPerView: showOnDesktop
                }
            }
        });
    });
});